// [S-060a] Application top bar — breadcrumbs (left), universal inline
// search (right). The decorative notifications-bell + help (?) icons were
// removed (S-491): they were silent no-ops, and per the no-fake-UI rule a
// control either works or shows NotYetBuilt. Class names mirror the wireframe.
import { useSession } from "../auth/AuthProvider";
import { InlineSearch } from "./InlineSearch";

export function TopBar({
  crumb,
  navOpen = false,
  onMenuToggle,
  sidebarCollapsed = false,
  onToggleSidebar,
}: {
  crumb: string;
  navOpen?: boolean;
  onMenuToggle?: () => void;
  sidebarCollapsed?: boolean;
  onToggleSidebar?: () => void;
}): JSX.Element {
  const session = useSession();
  const studio = prettyStudio(session?.studioId);
  return (
    <div className="tb">
      {/* S-399 — desktop sidebar hide/show. Hidden on mobile (the drawer
          hamburger below handles that breakpoint). */}
      <button
        type="button"
        className="tb__sb-toggle"
        aria-label={sidebarCollapsed ? "Show sidebar" : "Hide sidebar"}
        aria-expanded={!sidebarCollapsed}
        aria-controls="app-sidebar"
        title={sidebarCollapsed ? "Show sidebar" : "Hide sidebar"}
        onClick={onToggleSidebar}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="4" width="18" height="16" rx="2" />
          <line x1="9" y1="4" x2="9" y2="20" />
        </svg>
      </button>
      {/* S-381 — mobile nav toggle. Hidden on desktop via CSS. */}
      <button
        type="button"
        className="tb__menu"
        aria-label={navOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={navOpen}
        aria-controls="app-sidebar"
        onClick={onMenuToggle}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          {navOpen ? (
            <>
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </>
          ) : (
            <>
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </>
          )}
        </svg>
      </button>
      <div className="tb__crumbs">
        <span className="tb__crumbs-lbl">Organization:</span> <b>{studio}</b> /{" "}
        {crumb}
      </div>
      {/* [S-416] Universal inline search — type in the bar, results drop down. */}
      <InlineSearch />
    </div>
  );
}

function prettyStudio(studioId: string | null | undefined): string {
  if (studioId === undefined || studioId === null) return "ContractStudio";
  return studioId[0]!.toUpperCase() + studioId.slice(1);
}
